"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.framerActions = exports.FRAMER_BG = exports.FRAMER_COLOR = exports.FRAMER_CATEGORY = exports.framerActionsArgsSchema = exports.FramerAction = exports.framerPerformTaskResultSchema = exports.framerPerformTaskArgsSchema = exports.framerGetPublishUrlsResultSchema = exports.framerGetPublishUrlsArgsSchema = exports.framerUpdateArticleResultSchema = exports.framerUpdateArticleArgsSchema = exports.framerCreateArticleResultSchema = exports.framerCreateArticleArgsSchema = exports.framerGetArticleResultSchema = exports.framerGetArticleArgsSchema = exports.framerListArticlesResultSchema = exports.framerListArticlesArgsSchema = exports.framerListCollectionsResultSchema = exports.framerListCollectionsArgsSchema = void 0;
var zod_1 = require("zod");
var common_1 = require("./common");
// ---------- List Collections ----------
exports.framerListCollectionsArgsSchema = zod_1.z.object({});
exports.framerListCollectionsResultSchema = zod_1.z.object({
    collections: zod_1.z.array(zod_1.z.object({
        id: zod_1.z.string(),
        name: zod_1.z.string(),
        fieldCount: zod_1.z.number(),
    })),
});
// ---------- List Articles ----------
exports.framerListArticlesArgsSchema = zod_1.z.object({
    collectionName: zod_1.z
        .string()
        .describe('Name of the CMS collection (e.g., "Blog Posts", "Articles")'),
    limit: zod_1.z.number().nullish().describe('Maximum number of articles to return'),
    skip: zod_1.z.number().nullish().describe('Number of articles to skip (for pagination)'),
    searchQuery: zod_1.z.string().nullish().describe('Search query to filter articles'),
});
exports.framerListArticlesResultSchema = zod_1.z.object({
    articles: zod_1.z.array(zod_1.z.object({
        id: zod_1.z.string(),
        slug: zod_1.z.string(),
        draft: zod_1.z.boolean(),
        fieldData: zod_1.z.record(zod_1.z.any()),
    })),
    total: zod_1.z.number(),
});
// ---------- Get Article ----------
exports.framerGetArticleArgsSchema = zod_1.z.object({
    collectionName: zod_1.z
        .string()
        .describe('Name of the CMS collection (e.g., "Blog Posts", "Articles")'),
    slug: zod_1.z.string().describe('URL slug of the article'),
});
exports.framerGetArticleResultSchema = zod_1.z.object({
    id: zod_1.z.string(),
    slug: zod_1.z.string(),
    draft: zod_1.z.boolean(),
    fieldData: zod_1.z.record(zod_1.z.any()),
});
// ---------- Create Article ----------
exports.framerCreateArticleArgsSchema = zod_1.z.object({
    collectionName: zod_1.z
        .string()
        .describe('Name of the CMS collection (e.g., "Blog Posts", "Articles")'),
    slug: zod_1.z.string().describe('URL-friendly slug for the article'),
    draft: zod_1.z.boolean().default(true).describe('Whether the article is a draft (default: true)'),
    fieldData: zod_1.z
        .record(zod_1.z.any())
        .describe('Field data for the article (keys must match collection field names)'),
});
exports.framerCreateArticleResultSchema = zod_1.z.object({
    id: zod_1.z.string(),
    slug: zod_1.z.string(),
    draft: zod_1.z.boolean(),
});
// ---------- Update Article ----------
// Discriminated union for content update types
var fullFieldUpdate = zod_1.z.object({
    updateType: zod_1.z.literal('full'),
    fieldData: zod_1.z.record(zod_1.z.any()).describe('Complete field data (replaces all fields)'),
});
var changesFieldUpdate = zod_1.z.object({
    updateType: zod_1.z.literal('changes'),
    changes: zod_1.z.array(common_1.contentChangeSchema).min(1).describe('Apply incremental text changes'),
});
var partialFieldUpdate = zod_1.z.object({
    updateType: zod_1.z.literal('partial'),
    fieldData: zod_1.z.record(zod_1.z.any()).describe('Partial field data (updates only specified fields)'),
});
exports.framerUpdateArticleArgsSchema = zod_1.z.object({
    collectionName: zod_1.z
        .string()
        .describe('Name of the CMS collection (e.g., "Blog Posts", "Articles")'),
    itemId: zod_1.z.string().describe('ID of the article to update'),
    slug: zod_1.z.string().nullish().describe('New slug for the article'),
    draft: zod_1.z.boolean().nullish().describe('Whether the article should be a draft'),
    fieldUpdate: zod_1.z
        .discriminatedUnion('updateType', [fullFieldUpdate, changesFieldUpdate, partialFieldUpdate])
        .nullish()
        .describe('How to update article fields (mutually exclusive options)'),
});
exports.framerUpdateArticleResultSchema = zod_1.z.object({
    id: zod_1.z.string(),
    slug: zod_1.z.string(),
    draft: zod_1.z.boolean(),
    updated: zod_1.z.boolean(),
});
// ---------- Get Publish URLs ----------
exports.framerGetPublishUrlsArgsSchema = zod_1.z.object({});
exports.framerGetPublishUrlsResultSchema = zod_1.z.object({
    productionUrl: zod_1.z.string().url().nullable().describe('Production site URL'),
    stagingUrl: zod_1.z.string().url().nullable().describe('Staging site URL'),
});
// ---------- Perform Task ----------
exports.framerPerformTaskArgsSchema = zod_1.z.object({
    task: zod_1.z.string().describe("Natural language description of task to perform on the Framer site. Should include all necessary details about what needs to be done, which pages to target, what content to change, etc.\n      \n      INPORTANT:\n      Make sure you include all the necessary details required to perform the task. For example:\n      - If you need to create a CMS item, include the collection name, item name, slug, and content.\n      - If you need to update a page, include the page name, slug, and exactly what content you want to change and in what way.\n\n      This agent is not good at writing content, so pass in the content you want to use, and describe how you want to use it.\n      "),
});
exports.framerPerformTaskResultSchema = zod_1.z.object({
    summary: zod_1.z.string().describe('Summary of what was accomplished'),
    changes: zod_1.z
        .array(zod_1.z.object({
        action: zod_1.z.string().describe('Action taken'),
        target: zod_1.z.string().describe('What was targeted (page, collection, etc.)'),
        details: zod_1.z.string().describe('Specific details about the change'),
    }))
        .describe('List of changes made'),
});
// ==========================
// Compound Tool: framerActions
// ==========================
exports.FramerAction = zod_1.z.enum([
    //'listCollections',
    //'listArticles',
    'getArticle',
    'createArticle',
    'updateArticle',
    //'getPublishUrls',
    'performTask',
]);
exports.framerActionsArgsSchema = zod_1.z.object({
    action: zod_1.z.discriminatedUnion('name', [
        //z.object({ name: z.literal('listCollections'), params: framerListCollectionsArgsSchema }),
        //z.object({ name: z.literal('listArticles'), params: framerListArticlesArgsSchema }),
        zod_1.z.object({ name: zod_1.z.literal('getArticle'), params: exports.framerGetArticleArgsSchema }),
        zod_1.z.object({ name: zod_1.z.literal('createArticle'), params: exports.framerCreateArticleArgsSchema }),
        zod_1.z.object({ name: zod_1.z.literal('updateArticle'), params: exports.framerUpdateArticleArgsSchema }),
        //z.object({ name: z.literal('getPublishUrls'), params: framerGetPublishUrlsArgsSchema }),
        zod_1.z
            .object({ name: zod_1.z.literal('performTask'), params: exports.framerPerformTaskArgsSchema })
            .describe('Prefer to NOT use this action in Workflows. Instead, create a generic workflow and then use the "Framer Task Performer" tool with the results of that workflow.'),
    ]),
    emitMode: zod_1.z.literal('single'),
});
// Union of all possible result shapes
var FramerActionsAllResultsSchema = zod_1.z.union([
    //framerListCollectionsResultSchema,
    //framerListArticlesResultSchema,
    exports.framerGetArticleResultSchema,
    exports.framerCreateArticleResultSchema,
    exports.framerUpdateArticleResultSchema,
    //framerGetPublishUrlsResultSchema,
    exports.framerPerformTaskResultSchema,
]);
// Dynamic result schemas keyed by action
var framerActionsResultSchemas = (0, common_1.defineDynamicSchemas)()({
    dependencies: ['action.name'],
    variants: [
        //{ when: { 'action.name': 'listCollections' }, schema: framerListCollectionsResultSchema },
        //{ when: { 'action.name': 'listArticles' }, schema: framerListArticlesResultSchema },
        { when: { 'action.name': 'getArticle' }, schema: exports.framerGetArticleResultSchema },
        { when: { 'action.name': 'createArticle' }, schema: exports.framerCreateArticleResultSchema },
        { when: { 'action.name': 'updateArticle' }, schema: exports.framerUpdateArticleResultSchema },
        //{ when: { 'action.name': 'getPublishUrls' }, schema: framerGetPublishUrlsResultSchema },
        { when: { 'action.name': 'performTask' }, schema: exports.framerPerformTaskResultSchema },
    ],
    defaultSchema: FramerActionsAllResultsSchema,
});
exports.FRAMER_CATEGORY = common_1.ToolCategorySchema.enum.integration;
exports.FRAMER_COLOR = common_1.BRAND_COLORS.FRAMER;
exports.FRAMER_BG = (0, common_1.createBgColor)(exports.FRAMER_COLOR);
// Compound tool metadata
exports.framerActions = (0, common_1.createToolMetadata)({
    id: 'framerActions',
    displayName: 'Framer',
    displayDescription: 'Manage Framer CMS and perform agentic tasks on Framer sites',
    category: exports.FRAMER_CATEGORY,
    color: exports.FRAMER_COLOR,
    backgroundColor: exports.FRAMER_BG,
    icon: 'framer',
    argsSchema: exports.framerActionsArgsSchema,
}, framerActionsResultSchemas);
